import { handleReturnUrl } from './handleReturnUrl';

export type StoredReturnUrl = {
  url: string;
  owner: string | undefined;
};

/**
 * Resolves where to send a user after authentication. A stored owner means
 * the URL was captured from that user's session (on session expiry); a
 * different or unverifiable current user is never sent back to it (the
 * shared-computer guard, mirroring use-restore-return-url-on-reauth on the
 * application surface) and falls through to the admin default instead. An
 * ownerless URL (a guest deep link captured at boot) resumes for anyone;
 * route guards and the backend still decide whether the page is accessible.
 */
export const resolveReturnUrl = (
  stored: StoredReturnUrl,
  currentUserSub: string | undefined,
  loginPath: string,
  adminPath: string,
  authPath?: string,
  pathsToIgnore: readonly string[] = [],
): string => {
  const ownedByAnotherUser =
    !!stored.owner && (!currentUserSub || stored.owner !== currentUserSub);

  return handleReturnUrl(
    ownedByAnotherUser ? '' : stored.url,
    loginPath,
    adminPath,
    authPath,
    pathsToIgnore,
  );
};
